export const EDIT_COLUMN_WIDTH = 50;
